<div class="relative w-full h-full">
  <div class="absolute left-0 top-0 flex flex-col flex-grow-1 flex-shrink-0 w-full">
    @for (hour of hours; track hour) {
      <div
        class="w-full one-hour-border"
        [style.height.px]="config.oneHourHeight"
        [attr.data-hrs]="hour"
      >
        @for (quarter of quarters; track quarter) {
          <div
            class="quarter-border"
            [class.active]="activeHours[hour]?.[quarter]"
            (click)="onAddClick(hour, quarter)"
            (mouseover)="onQuarterMouseOver(hour, quarter)"
            (mouseleave)="onQuarterMouseLeave()"
          ></div>
        }
      </div>
    }
  </div>
  <div
    class="relative left-0 top-0 z-[1] w-full"
    [class.h-full]="isDragging$ | async"
    cdkDropList
    [cdkDropListData]="calendar ?? selectedDate"
    [cdkDropListSortingDisabled]="true"
    [cdkDropListDisabled]="isEventDragDisabled"
    (cdkDropListDropped)="onDragDropped($event)"
  >
    @for (layout of layoutEvents; track trackById(layout); let i = $index) {
      @let ctx =
        {
          height:
            layout.dimensions.height | eventHeight: config.oneHourHeight : paddingPx : timeScale,
          top:
            layout.position.top
            | eventPositionTop: config.oneHourHeight : paddingPx : availableHours.min : timeScale,
        };
      <div
        class="layout-event"
        [style.left.%]="layout.position.left * 100"
        [style.top.px]="ctx.top"
        [style.width.%]="layout.dimensions.width * 100"
        [style.z-index]="layout.index"
        [style.height.px]="ctx.height"
        [attr.topPx]="ctx.top"
        [attr.leftPx]="layout.position.left * 100"
        [attr.zi]="layout.index"
        cdkDrag
        #dragInstance="cdkDrag"
        [blazeEventDragMove]="dragInstance"
        [oneHourHeight]="config.oneHourHeight / timeScale"
        cdkDragPreviewContainer="global"
        cdkDragPreviewClass="opacity-50"
        [cdkDragData]="layout.event"
        (mousedown)="onDragMouseDown($event)"
        (mouseup)="onDragMouseUp()"
        (cdkDragStarted)="onDragStart($event)"
        (cdkDragMoved)="onDragMoved($event)"
        (eventMoved)="onEventMoved($event, layout.event)"
      >
        <blaze-calendar-event
          class="group"
          [blazeEventDragResize]="config.oneHourHeight / timeScale"
          [calendarEventLayout]="layout"
          [isEventDragDisabled]="isEventDragDisabled"
          [height]="ctx.height"
          [timeFormat]="timeFormat"
          [fontSize]="eventFontSize"
          [timeScale]="timeScale"
          (details)="onEventClick(layout.event)"
          (eventChange)="onEventChange($event, layout.event)"
        >
          <div
            class="absolute top-0 right-0 hidden group-hover:flex items-center justify-end gap-4"
            [class.p-8]="layout.dimensions.height > 0.5"
            [class.p-2]="layout.dimensions.height <= 0.5"
          >
            @if (isEditEnabled) {
              <button
                type="button"
                class="action-button"
                (click)="onEditClick(layout.event)"
                data-cy="Calendar:Event:Edit"
              >
                <mat-icon svgIcon="icon_edit_16" />
              </button>
            }
            @if (isDeleteEnabled) {
              <button
                type="button"
                class="action-button"
                (click)="onDeleteClick(layout.event)"
                data-cy="Calendar:Event:Delete"
              >
                <mat-icon svgIcon="icon_trash_16" />
              </button>
            }
          </div>
        </blaze-calendar-event>
      </div>
    }
  </div>
</div>
